import { captureException, captureMessage } from "@sentry/nextjs";

interface IAtomizeUrl {
  url: string;
  isIOS?: boolean;
}

export const atomizeUrl = ({ url, isIOS }: IAtomizeUrl) => {
  const urlOptionalParams = `&muted=true&autoplay=${!isIOS}&controls=''&playOpensFullscreen=${!isIOS}&smallMutedIcon=false`;

  if (!url) return;

  try {
    const playerIdPattern = /player-vz-[a-f0-9]{8}-[0-9]{3}/;
    const videoIdPattern =
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;

    const idPlayer = url.match(playerIdPattern);
    const idVideo = url.match(videoIdPattern);

    if (!idPlayer || !idVideo) {
      captureMessage(
        "Error ~ BrowserUtils::atomizeUrl: URL does not contain expected substrings",
      );
      return;
    }

    return `https://${idPlayer}.tv.pandavideo.com.br/embed/?v=${idVideo}${urlOptionalParams}`;
  } catch (error) {
    captureException(error);
    captureMessage("Error ~ BrowserUtils::atomizeUrl");
    return url;
  }
};
